import client from './client';

export const blackoutsApi = {
  async list(appId) {
    const { data } = await client.get(`/api/alert-apps/${appId}/blackouts`);
    return data;
  },

  async create(appId, payload) {
    const { data } = await client.post(`/api/alert-apps/${appId}/blackouts`, payload);
    return data;
  },

  async update(appId, id, payload) {
    const { data } = await client.patch(`/api/alert-apps/${appId}/blackouts/${id}`, payload);
    return data;
  },

  async del(appId, id) {
    const { data } = await client.delete(`/api/alert-apps/${appId}/blackouts/${id}`);
    return data;
  },
};
